/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EquipmentTypeCatalogDto } from './EquipmentTypeCatalogDto';
import {
    EquipmentTypeCatalogDtoFromJSON,
    EquipmentTypeCatalogDtoFromJSONTyped,
    EquipmentTypeCatalogDtoToJSON,
} from './EquipmentTypeCatalogDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfEquipmentTypeCatalogDto
 */
export interface ODataPostProcessedResultsOfEquipmentTypeCatalogDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfEquipmentTypeCatalogDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<EquipmentTypeCatalogDto>}
     * @memberof ODataPostProcessedResultsOfEquipmentTypeCatalogDto
     */
    value?: Array<EquipmentTypeCatalogDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfEquipmentTypeCatalogDto
     */
    $type?: ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfEquipmentTypeCatalogDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedDeviceComponentDtoEquipmentTypeCatalogDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.EquipmentTypeCatalogDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum = typeof ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfEquipmentTypeCatalogDto interface.
 */
export function instanceOfODataPostProcessedResultsOfEquipmentTypeCatalogDto(value?: unknown): value is ODataPostProcessedResultsOfEquipmentTypeCatalogDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfEquipmentTypeCatalogDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfEquipmentTypeCatalogDtoFromJSON(json: any): ODataPostProcessedResultsOfEquipmentTypeCatalogDto {
    return ODataPostProcessedResultsOfEquipmentTypeCatalogDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfEquipmentTypeCatalogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfEquipmentTypeCatalogDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(EquipmentTypeCatalogDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfEquipmentTypeCatalogDtoToJSON(value?: ODataPostProcessedResultsOfEquipmentTypeCatalogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(EquipmentTypeCatalogDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

